import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const window = require('global/window');

export function useResizeHeight() {
  const [height, setHeight] = React.useState(window.innerHeight);
  React.useEffect(() => {
    function onChange(event: UIEvent) {
      const target = event.target as Window;
      if (target) {
        setHeight(target.innerHeight);
      }
    }
    window.addEventListener('resize', onChange);
    return () => window.removeEventListener('resize', onChange);
  }, []);
  return height;
}
